export default "__VITE_ASSET__5b9e0711__"